<template>
  <div style="padding: 15px">
    <table border="1" style="width: 100%;">
      <thead style="background-color: #DCD9D9;">
        <tr>
          <th v-for="(oHeaders, i) in aHeaders" :key="i" scope="col" class="ntitlesdark--text" :style="`width: ${oHeaders.width}%; text-align: center; ${(oHeaders.visible == '0') ? 'display: none;' : ''}`">
            <h3 class="ntitlesdark--text">{{ oHeaders.text }}</h3>
          </th>
        </tr>
      </thead>
      <tbody v-if="aData.length == 0 && cargando">
        <tr>
          <td :colspan="aHeaders.length">
            <span class="font-weight-bold">No hay información</span>
          </td>
        </tr>
      </tbody> 
      <tbody v-else>
        <tr>
          <td>
            <div style="display: flex;">
              <v-container>
                <v-row dense>
                  <v-col v-for="(oImage, j) in aImage" :key="j" sm="3" md="3" lg="3" xl="3">
                    <div id="sImgReference" >
                      <img class="aFotos" style="margin: 10px; width: 180px; height: 180px;" :src="oImage"/>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axiosServices from '@/services/axiosServices.js'
export default {
  name: 'gridanidada',
  props: {
    sIdParent: {
      type: String,
      default: ''
    },
    sTabla: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      bShow: false,
      bIcon: false,
      aHeaders: [],
      aData: [],
      sURL: '',
      aImage: [],
      cargando: true
    }
  },
  mounted () {
    this.getURLImage()
  },
  methods: {
    getURLImage () {
      let sParams = 'sPath=Path_imagenes'
      axiosServices.getConfiguration('FormDinamicCorreo_Path', false, sParams).then(getPath => {
        this.sURL = getPath.aData.Observacion
        this.getHeaders()
      })
    },
    getHeaders () {
      this.cargando = true
      axiosServices.getConfiguration('/InformeRiesgos_headersGrid', true, `sTable=${this.sTabla}&level=three`).then(aHeaders =>{
        this.aHeaders = aHeaders.aData
        this.getData()
      })
    },
    getData () {
      let sParams = `sTable=${this.sTabla}&idparent=${this.sIdParent}&level=three`
      axiosServices.getConfiguration('/InformeRiesgos_DataGrid', true, sParams).then(aDataItems =>{
        this.aData = aDataItems.aData
        this.proccessData()
      })
    },
    ViewDetails (sIdIndex) {
      let tblDetail = document.getElementById(`${sIdIndex}`)
      if (tblDetail.style.display === "none") {
        tblDetail.style.display = "table-row";
        // tblDetail.style.border = "1px solid black"
        tblDetail.style["text-align"] = "center";
        this.bIcon = true
      } else {
        tblDetail.style.display = "none";
        // tblDetail.style.border = "1px solid black"
        tblDetail.style["text-align"] = "center";
        this.bIcon = false
      }
    },
    toDataURL (src, callback) {
      var img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function() {
        var canvas = document.createElement('canvas')
        var context = canvas.getContext('2d')
        canvas.height = this.naturalHeight
        canvas.width = this.naturalWidth
        context.drawImage(this, 0, 0)
        var dataURL = canvas.toDataURL('image/jpeg', 1.0)
        callback(dataURL)
      }
      img.src = src
    },
    proccessData () {
      this.aData.forEach(oImageName => {
        this.toDataURL(`${this.sURL}${oImageName[0].text}`, this.setValue)
      })
    },
    setValue(sBase64) {
      this.aImage.push(sBase64)
      this.cargando = false;
      this.resize()
    },
    resize () {
      if (window.addEventListener) {  // all browsers except IE before version 9
        window.addEventListener("resize", onResizeEvent, true);
      }
      function onResizeEvent() {
        let divImgElement = document.getElementById("sImgReference")
        let newWidth = divImgElement.clientWidth
        let aImgsRenders = document.getElementsByClassName("aFotos")
        aImgsRenders.forEach(oElementImg => {
          oElementImg.style.width = `${newWidth}px`
          oElementImg.style.height = `${newWidth}px`
        })
      }
    },
  }
}
</script>